import { map } from 'lodash';
import isEmpty from 'lodash/isEmpty';
import set from 'lodash/set';

export const withColor = (
  color: {
    r?: number;
    g?: number;
    b?: number;
    a?: number;
  } = {},
  defaultColor = 'transparent'
) => {
  if (isEmpty(color)) return defaultColor;
  return `rgba(${color?.r},${color?.g},${color?.b},${color?.a})`;
};

export function unflatten(errors: Record<string, string>): Record<string, any> {
  return Object.entries(errors).reduce((acc, [path, message]) => {
    set(acc, path, message);
    return acc;
  }, {} as Record<string, any>);
}

type Option<ID> = {
  id: ID;
  value: ID;
  label: string;
};

type ParserConfig<ID> = {
  parseValue: (key: any) => ID;
  parseLabel?: (label: any) => string;
};

export function mapDictionaryToOptions<
  T extends Record<string, unknown> | undefined,
  ID
>(data: T, parsers: ParserConfig<ID>): Option<ID>[] {
  const { parseValue, parseLabel } = parsers;
  return map(data, (label, key) => {
    const id = parseValue(key);
    return {
      id,
      value: id,
      label: parseLabel ? parseLabel(label) : String(label),
    };
  });
}
